/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Revenue } from "App/IOC/Services";

export default {
    Snapshot: Revenue.Snapshot
};
